import { render, staticRenderFns } from "./PaymentPanel.vue?vue&type=template&id=385380c9&scoped=true"
import script from "./PaymentPanel.vue?vue&type=script&lang=js"
export * from "./PaymentPanel.vue?vue&type=script&lang=js"
import style0 from "./PaymentPanel.vue?vue&type=style&index=0&id=385380c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385380c9",
  null
  
)

export default component.exports